export const groupBy = (keys: string) => (array: any[]): {} =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = get(obj, keys, undefined);
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

const get = (obj, path, defaultValue = undefined) => {
  const travel = regexp =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce(
        (res, key) => (res !== null && res !== undefined ? res[key] : res),
        obj
      );
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};



// WEBPACK FOOTER //
// ./src/app/utils/array-group-by.ts